import React from 'react'
import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import useFlightCreditTerms from './useFlightCreditTerms'

interface Props {
  flightCreditFee: number
  currency: string
  className?: string
}

function TermsAndConditionsList(props: Props) {
  const intl = useIntl()
  const { className, flightCreditFee, currency } = props
  const termsAndConditionsList = useFlightCreditTerms({ flightCreditFee, currency })

  return <VerticalSpacer gap={4} className={className}>
    {termsAndConditionsList.map((content, index) =>
      <BodyText key={index} variant="large">
        {intl.formatMessage(
          {
            id: 'y/PwcPwtmS',
            defaultMessage: '{number}. {content}',
            description: 'Numbered list item for terms and conditions',
          },
          {
            number: index + 1,
            content,
          },
        )}
      </BodyText>,
    )}
  </VerticalSpacer>
}

export default TermsAndConditionsList
